import api from './api';

/** Package A5 (#518): classic → v2 conversion report + copy. */
export type ConversionStatus = 'converted' | 'partial' | 'manual';

export interface ConversionLessonRow {
    sourceLessonId: number;
    title: string;
    type: string;
    status: ConversionStatus;
    blocks: number;
    blockTypes: string[];
    completionRule: string;
    notes: string[];
}

export interface ConversionSummary { total: number; converted: number; partial: number; manual: number }

export interface ConversionPreview { lessons: ConversionLessonRow[]; summary: ConversionSummary }

export interface ConversionResult extends ConversionPreview {
    course: { id: number; title: string; slug: string; isActive: boolean };
}

export const courseConversionService = {
    async preview(courseId: number): Promise<ConversionPreview> {
        const { data } = await api.get<ConversionPreview>(`/courses/${courseId}/conversion-preview`);
        return data;
    },
    async convert(courseId: number): Promise<ConversionResult> {
        const { data } = await api.post<ConversionResult>(`/courses/${courseId}/convert-to-blocks`);
        return data;
    },
};

export default courseConversionService;
